'use strict';

// @flow

var FirebaseUtils = {
  initFirebase: function initFirebase(fbAdmin, context, event) {
    // Get stage
    var stageVars = event['stage-variables'];
    var stage = stageVars && stageVars.stage === 'prod' ? 'prod' : 'dev';
    console.log('Stage: ', stage);

    context.callbackWaitsForEmptyEventLoop = false; //<---Important

    // In lambda, Avoid double initialization. Try to find a previous app
    // initialized with same database
    console.log('Number of firebaseApp: ' + fbAdmin.apps.length);
    for (var i = 0; i < fbAdmin.apps.length; i++) {
      if (fbAdmin.apps[i].name === stage) {
        console.log('Found an initialized firebase');
        return fbAdmin.apps[i];
      }
    }

    // Connect with dev or prod firebase
    var suffix = stage === 'prod' ? '' : '-dev';
    var accountKeyPath = 'firebaseAccountKey' + suffix + '.json';
    var databaseURL = 'https://fibo-collab' + suffix + '.firebaseio.com/';

    // Initialize a new Firebase App
    console.log('Initialize firebase from ' + accountKeyPath);
    return fbAdmin.initializeApp({
      credential: fbAdmin.credential.cert(accountKeyPath),
      databaseURL: databaseURL
    }, stage);
  },

  saveToFirebase: function saveToFirebase(dbRef, updates, callback, params) {
    console.log('saveToFirebase');
    dbRef.update(updates).then(function () {
      console.log('Firebase DONE');
      var successParams = { success: true };
      if (params) {
        Object.assign(successParams, params);
      }
      callback(null, successParams);
    }).catch(function (error) {
      console.log('ERROR: ' + JSON.stringify(error, null, 2));
      callback(error);
    });
  }
};

module.exports = FirebaseUtils;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/FirebaseUtils.js
// module id = 80
// module chunks = 0